import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { doc, serverTimestamp, setDoc } from "firebase/firestore";
import "./PasswordPrompt.css";
import { auth, db } from "../../../firebase";
import { ACCESS_MODES, setStoredAccessMode } from "../../../utils/accessMode";

const SECRET_PASSWORD = "Jairorebozado";
const PREMIUM_PASSWORD = "JuntaPremium";
const RESULTS_PASSWORD = "cigrunet";

const PasswordPrompt = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [feedback, setFeedback] = useState({ type: "", text: "" });

  const persistPremiumStatus = async (isPremium) => {
    const user = auth.currentUser;

    if (!user) {
      throw new Error("No hay una sesion autenticada para actualizar el estado premium.");
    }

    await setDoc(
      doc(db, "users", user.uid),
      {
        premium: isPremium,
        premiumUpdatedAt: serverTimestamp(),
      },
      { merge: true }
    );
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (password === SECRET_PASSWORD) {
      try {
        await persistPremiumStatus(false);
      } catch (error) {
        setFeedback({
          type: "error",
          text: "No hemos podido sincronizar tu estado premium en Firebase. Intentalo otra vez.",
        });
        return;
      }

      setStoredAccessMode(ACCESS_MODES.STANDARD);
      navigate("/home", {
        replace: true,
        state: {
          accessUnlocked: true,
          accessMode: ACCESS_MODES.STANDARD,
        },
      });
      return;
    }

    if (password === PREMIUM_PASSWORD) {
      try {
        await persistPremiumStatus(true);
      } catch (error) {
        setFeedback({
          type: "error",
          text: "No hemos podido guardar premium: true en Firebase. Revisa las reglas y vuelve a intentarlo.",
        });
        return;
      }

      setStoredAccessMode(ACCESS_MODES.PREMIUM);
      navigate("/home", {
        replace: true,
        state: {
          accessUnlocked: true,
          accessMode: ACCESS_MODES.PREMIUM,
        },
      });
      return;
    }

    if (password === RESULTS_PASSWORD) {
      navigate("/resultados", { replace: true });
      return;
    }

    setFeedback({
      type: "error",
      text: "Clave incorrecta. Revisa la contrasena e intentalo otra vez.",
    });
  };

  return (
    <div className="password-page">
      <div className="password-ambient" />
      <div className="password-card">
        <p className="password-kicker">Acceso privado</p>
        <h1>Panel de acceso especial</h1>
        <p className="password-copy">
          Esta pantalla ya no interrumpe el flujo principal. Solo se usa para desbloquear modos
          especiales o consultar resultados protegidos.
        </p>

        <form className="password-form" onSubmit={handleSubmit}>
          <label className="password-field">
            <span>Clave privada</span>
            <input
              className="inputPass"
              type="password"
              value={password}
              onChange={(event) => {
                setPassword(event.target.value);
                if (feedback.text) {
                  setFeedback({ type: "", text: "" });
                }
              }}
              placeholder="Introduce la clave"
              required
            />
          </label>

          {feedback.text ? (
            <p className={`password-feedback ${feedback.type}`} aria-live="polite">
              {feedback.text}
            </p>
          ) : null}

          <div className="password-actions">
            <button className="secondary-access-button" type="button" onClick={() => navigate("/home")}>
              Volver a la home
            </button>
            <button
              className="secondary-access-button"
              type="button"
              onClick={() => navigate("/admin-access")}
            >
              Panel admin
            </button>
            <button className="accesButton" type="submit">
              Desbloquear
            </button>
          </div>
        </form>

        <p className="password-note">
          Jairorebozado mantiene el acceso privado estandar. JuntaPremium activa la ponderacion
          premium y persiste `premium: true` en Firestore. cigrunet conserva la entrada a
          resultados. El panel admin usa una clave distinta.
        </p>
      </div>
    </div>
  );
};

export default PasswordPrompt;
